var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.label,"eager":false}},[_c('span',{staticClass:"text-body-2 my-2"},[_vm._v(_vm._s(_vm.$tc('common.column', 2)))]),_c('c-columns-field',_vm._b({model:{value:(_vm.columns),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"columns"}},'c-columns-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }